<template>
  <div class="predicted-transaction-row-container" :id="predictedTransaction.envelopeId" :class="{'editable': canEditEnvelope }">
    <div>
      <div class="predicted-transaction-row">
        <div class="transaction-name">
          <span class="name">{{ predictedTransaction.name }}</span>
        </div>
      </div>
      <div class="amounts-row">
        <div class="actual-amount">{{ formatAmountWithFractionAndCurrency(actualAmount, 1) }}</div>
        <div v-if="showPrediction" class="predicted-amount">{{ formatAmountWithFractionAndCurrency(predictedTransaction.predictedAmount, 1) }}</div>
      </div>
      <div class="more-details">
        <template v-if="hasActual">
          <img class="icon" :src="require('@/assets/subdirectory-arrow-left@3x.png')">
          <span>{{ formatDate(predictedTransaction.actual.transactionDate) }} </span>
          <span class="transaction-name">{{ predictedTransaction.actual.businessName }} </span>
          <span>{{ getTransactionPayment(predictedTransaction.actual) }}</span>
          <span>{{ getTransactionAccount(predictedTransaction.actual) }}</span>
        </template>
      </div>
    </div>
    <div class="three-dots" v-if="canEditEnvelope">
      <img :src="require('@/assets/icons/light-three-dots.svg')" v-if="isSelected">
      <img :src="require('@/assets/icons/three-dots.svg')" v-else>
    </div>
  </div>
</template>

<script>
import TransactionDisplayUtils from '../../TransactionDisplayUtils.vue';

export default {
  name: 'PredictedTransactionRow',
  mixins: [TransactionDisplayUtils],
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    canEditEnvelope: {
      type: Boolean,
      required: false,
      default: true,
    },
    showPrediction: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasActual() {
      return this.predictedTransaction.actual;
    },
    actualAmount() {
      if (this.hasActual) {
        // TODO yack!
        return this.predictedTransaction.actual.billingAmount
          ? this.predictedTransaction.actual.billingAmount
          : this.predictedTransaction.actual.incomeAmount;
      }
      return 0;
    },
  },
};
</script>
<style scoped lang="scss">
  @import '~base-ui/src/scss/riseup-colors';

  .predicted-transaction-row-container {
    padding: 8px 10px 4px 4px;
    display: flex;
    justify-content: space-between;

    &.editable {
      cursor: pointer;
    }

    .predicted-transaction-row {
      display: flex;
      justify-content: space-between;
      height: 15px;
      font-size: 10px;
      line-height: 1;

      .transaction-name {
        display: flex;

        .edit-container {
          width: 16px;
          height: 16px;
          border-radius: 3px;
          background-color: var(--pencil-bg-color);
          margin-top: -2px;
          margin-left: 7px;

          &.wiggle {
            animation: fadein 1.5s ease-out;
            animation-iteration-count: 3;

            @keyframes fadein {
              50% {
                opacity: 0;
              }
            }
          }

          .edit {
            margin-right: 3px;
            margin-top: 3px;
            width: 10px;
            height: 10px;
          }

        }

        .name {
          max-width: 230px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .amounts-row {
      display: flex;
      padding-right: 90px;
      height: 14px;
      line-height: 14px;
      font-size: 10px;

      .actual-amount {
        width: 88px;
        font-weight: bold;
      }

      .predicted-amount {
        width: 60px;
      }
    }

    .more-details {
      display: flex;
      white-space: nowrap;
      height: 14px;
      font-size: 10px;
      line-height: 1;
      color: $riseup_gray_3;
      margin-top: 4px;

      span {
        overflow: hidden;
        padding-left: 2px;
      }

      .transaction-name {
        max-width: 126px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      img {
        margin-top: 2px;
        height: 6px;
      }
    }
    .three-dots {
      padding: 12px 0 0 15px;
      color: $riseup_gray_3;
    }
  }
</style>
